<form [formGroup]="formGroup" [class]="subform ? '' : 'form form--inline'" (ngSubmit)="submit()">
    <h4 class="u-margin-bottom--20" *ngIf="!subform">{{ rule ? 'Update' : 'Create' }} rent match rule</h4>

    <ng-container *ngIf="rule || (!rule && !tenancyGuid)">
        <label class="form__label">Tenancy</label>
        <searchable-dropdown
            formControlName="tenancyGuid"
            [options]="tenanciesOptions"
            [small]="false"
            [loading]="gettingTenancies.loading"/>
        <div class="form__input-help">
            <p>You can only pick from active tenancies</p>
        </div>
    </ng-container>

    <error-response-summary [responseErrors]="gettingTenancies.responseErrors" (onTryAgain)="getTenancies()"/>

    <p class="u-text--small u-margin-top--10 u-text-color--grey">
        <ng-container *ngIf="gettingTenancyRules.loading">
            Loading existing rules for this tenancy...
        </ng-container>
        <ng-container *ngIf="!gettingTenancyRules.loading">
            <ng-container *ngIf="tenancyRulesTotalCount > 1">
                There are {{ tenancyRulesTotalCount }}{{ rule ? ' other' : ''}} existing rules for this tenancy.<span *ngIf="tenancyRulesTotalCount > tenancyRentMatchRules.length"> The list below only shows the first 10 results.</span><a class="u-margin-left--5" href="javascript:void(0)" (click)="toggleShowTenancyRules()">{{ showTenancyRules ? 'Hide' : 'Show'}} list</a>
            </ng-container>
            <ng-container *ngIf="tenancyRulesTotalCount === 0 ">
                There are no{{ rule ? ' other' : ''}} existing rules for this tenancy.
            </ng-container>
            <ng-container *ngIf="tenancyRulesTotalCount === 1">
                There is 1{{ rule ? ' other' : ''}} existing rule for this tenancy: {{ RentRuleMatchBehaviourReverseAction[tenancyRentMatchRules[0].behaviour] }} when a transaction description {{StringMatchTypeReverse[tenancyRentMatchRules[0].transactionDescriptionMatchType].toLowerCase()}} {{tenancyRentMatchRules[0].transactionDescription}}.
            </ng-container>
        </ng-container>
    </p>

    <table class="compact__table compact__table--narrow u-margin-bottom--30 u-margin-top--10" *ngIf="tenancyRulesTotalCount > 1 && showTenancyRules">
        <thead>
        <tr>
            <th>Behaviour</th>
            <th>Match type</th>
            <th>Description</th>
        </tr>
        </thead>
        <tbody class="max-height--500">
        <ng-container *ngFor="let rule of tenancyRentMatchRules">
            <tr class="summary">
                <td>
                    <span class="label">Behaviour</span>
                    {{RentRuleMatchBehaviourReverse[rule.behaviour]}}
                </td>
                <td>
                    <span class="label">Match type</span>
                    {{StringMatchTypeReverse[rule.transactionDescriptionMatchType]}}
                </td>
                <td>
                    <span class="label">Description</span>
                    {{rule.transactionDescription}}
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>

    <error-response-summary [responseErrors]="gettingTenancyRules.responseErrors" (onTryAgain)="getTenancies()"/>
    <error-response-summary [responseErrors]="gettingTenancies.responseErrors" (onTryAgain)="getTenancies()"/>

    <div class="form__grid form__grid-3--medium">
        <div class="form__grid-element">
            <label class="form__label">Match type</label>
            <dropdown formControlName="transactionDescriptionMatchType" [options]="transactionDescriptionMatchTypeOptions"/>
        </div>
        <div class="form__grid-element--double">
            <label class="form__label">Description</label>
            <textbox formControlName="transactionDescription" [minLength]="3" [maxLength]="128"/>
        </div>
    </div>

    <p class="u-text--small u-margin-top--10" *ngIf="!showPayeeFormField">
        <ng-container *ngIf="formGroup.get('payeeName').value">Restrict to payee {{formGroup.get('payeeName').value}}.</ng-container>
        <ng-container *ngIf="!formGroup.get('payeeName').value">No restriction around the payee's name.</ng-container>
        <a href="javascript:void(0)" (click)="toggleShowPayeeFormField()" class="u-margin-left--5">Change</a>
    </p>

    <ng-container *ngIf="showPayeeFormField">
        <label class="form__label">Payee <span class="form__label-subtext">Optional</span></label>
        <textbox formControlName="payeeName" [maxLength]="64"/>
    </ng-container>

    <error-response-summary [responseErrors]="checkingMatchingTransactions.responseErrors"/>
    <div class="button__group u-margin-top--10">
        <div class="button__group-item">
            <loader-button
                cssClasses="button--small button--ghost"
                [loading]="checkingMatchingTransactions.loading"
                [icon]="true"
                [iconName]="IconNames.viewing"
                [disabled]="!formGroup.get('transactionDescription').value"
                (click)="checkMatchingTransactions()">
                Preview matches
            </loader-button>
        </div>
    </div>

    <div *ngIf="transactionsList">
        <table class="compact__table compact__table--narrow u-margin-bottom--30 u-margin-top--10" *ngIf="transactionsList.transactions?.length">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody class="max-height--500">
                <ng-container *ngFor="let tr of transactionsList.transactions; let i = index">
                    <tr class="summary">
                        <td>
                            <span class="label">Date</span>
                            {{tr.date | houseShareDate:DateFormats.VERY_SHORT}}
                        </td>
                        <td>
                            <span class="label">Description</span>
                            {{tr.description}}
                        </td>
                        <td class="amount">
                            <span class="label">Amount</span>
                            {{tr.amount | houseShareCurrency:true}}
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <p class="u-text--small">
            Found {{ transactionsList.totalCount}} matches since {{transactionsListSince | houseShareDate:DateFormats.VERY_SHORT}}{{ transactionsList.totalCount > transactionsList.transactions.length ? ', showing 10' : '' }}.
        </p>
    </div>



    <label class="form__label">Behaviour</label>
    <div class="form__grid form__grid-3--medium">
        <div class="form__grid-element">
            <radio-button
                formControlName="behaviour"
                [internalValue]="RentRuleMatchBehaviour.PROPOSE_MATCHES_LEGACY_STYLE"
                [title]="true"
                [label]="RentRuleMatchBehaviourRadioButtonLabel[RentRuleMatchBehaviour.PROPOSE_MATCHES_LEGACY_STYLE]"
                [description]="RentRuleMatchBehaviourRadioButtonDescription[RentRuleMatchBehaviour.PROPOSE_MATCHES_LEGACY_STYLE]"/>
        </div>
        <div class="form__grid-element">
            <radio-button
                formControlName="behaviour"
                [internalValue]="RentRuleMatchBehaviour.AUTO_YOUNGEST_FIRST"
                [title]="true"
                [label]="RentRuleMatchBehaviourRadioButtonLabel[RentRuleMatchBehaviour.AUTO_YOUNGEST_FIRST]"
                [description]="RentRuleMatchBehaviourRadioButtonDescription[RentRuleMatchBehaviour.AUTO_YOUNGEST_FIRST]"/>
        </div>
        <div class="form__grid-element">
            <radio-button
                formControlName="behaviour"
                [internalValue]="RentRuleMatchBehaviour.AUTO_OLDEST_FIRST"
                [title]="true"
                [label]="RentRuleMatchBehaviourRadioButtonLabel[RentRuleMatchBehaviour.AUTO_OLDEST_FIRST]"
                [description]="RentRuleMatchBehaviourRadioButtonDescription[RentRuleMatchBehaviour.AUTO_OLDEST_FIRST]"/>
        </div>
    </div>

    <error-summary [errors]="errors"/>
    <error-response-summary [responseErrors]="formState.responseErrors"/>

    <div class="button__group u-margin-top--20" *ngIf="!subform">
        <div class="button__group-item">
            <loader-button type="submit" [loading]="formState.loading">{{ rule ? 'Update' : 'Create' }} rule</loader-button>
        </div>
        <div class="button__group-item">
            <loader-button cssClasses="button--cancel" (click)="close()">Close</loader-button>
        </div>
    </div>
</form>
